module.exports = __webpack_public_path__ + "img/icon／20wjj.76da555f.svg";